import { render, staticRenderFns } from "./KBTZ.vue?vue&type=template&id=71022860&scoped=true&"
import script from "./KBTZ.vue?vue&type=script&lang=js&"
export * from "./KBTZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71022860",
  null
  
)

export default component.exports